<template>
<div>
    <div class="ibox animated fadeInRightBig">
        <div class="ibox-title">
            <h3>Novo Turno <i class="fa fa-clock-o" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
        </div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="name"><span class="required">*</span> Nome do Turno</label>
                        <input type="text" class="form-control" name="name" v-model="shift.name" id="name" />
                    </div>
                    <div class="form-group col-md-6">
                        <label for="short_name"><span class="required">*</span> Nome Abreviado</label>
                        <input type="text" class="form-control" name="short_name" v-model="shift.short_name" id="short_name" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="days">Selecione os dias de trabalho:</label>
                        <ul>
                            <li>
                                <input type="checkbox" name="day" value="sunday" v-model="shift.sunday"> Domingo
                            </li>
                            <li>
                                <input type="checkbox" name="day" value="monday" v-model="shift.monday"> Segunda-feira
                            </li>
                            <li>
                                <input type="checkbox" name="day" value="tuesday" v-model="shift.tuesday"> Terça-feira
                            </li>
                            <li>
                                <input type="checkbox" name="day" value="wednesday" v-model="shift.wednesday"> Quarta-feira
                            </li>
                            <li>
                                <input type="checkbox" name="day" value="thursday" v-model="shift.thursday"> Quinta-feira
                            </li>
                            <li>
                                <input type="checkbox" name="day" value="friday" v-model="shift.friday"> Sexta-feira
                            </li>
                            <li>
                                <input type="checkbox" name="day" value="saturaday" v-model="shift.saturday"> Sábado
                            </li>
                        </ul>
                    </div>

                    <div class="form-group col-md-3">
                        <label for="initial_hour"><span class="required">*</span> Hora Inicial</label>
                        <div class="input-group clockpicker">
                            <input id="initial_hour" type="time-local" v-model="shift.initial_hour" class="form-control initial_hour" placeholder="hh:mm">
                            <span class="input-group-addon">
                                <span class="glyphicon glyphicon-time"></span>
                            </span>
                        </div>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="final_hour"><span class="required">*</span> Hora Final</label>
                        <div class="input-group clockpicker">
                            <input id="final_hour" type="time-local" v-model="shift.final_hour" class="form-control final_hour" placeholder="hh:mm">
                            <span class="input-group-addon">
                                <span class="glyphicon glyphicon-time"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/shifts" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            shift: {
                name: '',
                shortname: ''
            },
            errors: undefined
        }
    },
    computed: {},
    methods: {
        save: function () {
            const self = this;

            self.shift.initial_hour = $('#initial_hour').val();
            self.shift.final_hour = $('#final_hour').val();

            const api = self.$store.state.api + 'shifts';

            self.$http.post(api, self.shift)
                .then((response) => {
                    self.shifts = response.data.data;
                    self.tableData = self.shifts;

                    self.$message('Sucesso', `Turno cadastrado com sucesso`, 'success');

                    this.$router.push('/shifts');

                    self.shift = {
                        name: ''
                    };
                })
                .catch((error) => {
                    self.errors = error.response.data;

                    if (typeof self.errors === 'object') {
                        let html = '<ul>';

                        $.each(self.errors, function (key, value) {
                            html += '<li>' + value[0] + '</li>';
                        });

                        html += '</ul>';

                        self.errors = html;
                    }

                    self.$message(null, self.errors, 'error');
                });
        },
        getShifts() {
            const self = this;
            const api = self.$store.state.api + 'shifts';

            self.$http.get(api)
                .then(function (response) {
                    // console.log(response);
                });
        }

    },

    mounted: function () {
        // console.log(this.$store.state.user);
        this.getShifts();
        $('.clockpicker').clockpicker();
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
li.inline>input[type="checkbox"] {
    vertical-align: sub;
}

li.inline {
    padding-right: 5px;
}

.no-padding {
    padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Shift/Add.vue